import { Link } from 'react-router-dom'
import type { ToolDefinition } from '../../data/tools'

type ToolCardProps = {
  tool: ToolDefinition
  featured?: boolean
}

export function ToolCard({ tool, featured = false }: ToolCardProps) {
  return (
    <article className={`tool-card ${featured ? 'tool-card--featured' : ''}`}>
      <div className="tool-card__topline">
        <span className="tool-card__icon" aria-hidden="true">{tool.icon ?? 'IMG'}</span>
        <span className="status-chip status-chip--available">Available</span>
      </div>
      <div>
        <h3>{tool.name}</h3>
        <p>{tool.description}</p>
      </div>
      <div className="tool-card__footer">
        <span className="tool-card__privacy"><span aria-hidden="true">●</span> {tool.privacyNote}</span>
        <Link className="button button--dark" to={tool.path}>Open tool <span aria-hidden="true">→</span></Link>
      </div>
    </article>
  )
}
